import { mapState, mapActions } from "vuex";
import ConnectionTabsRenderer from "@/components/shared/ConnectionTabsRenderer";
import AmazonSellerCentralPage from "@/pages/AmazonSellerCentralPage";
import AmazonConnectionPage from "@/pages/AmazonConnectionPage";
// import AmazonAdvertisingPage from "@/pages/AmazonAdvertisingPage";
import AppPagination from "@/components/AppPagination.vue";
import AppIcon from "@/components/AppIcon";
import AppInput from "@/components/AppInput";
import AddAccountSideBar from "@/components/AddAccountSideBar";
export default {
  name: "ConnectionsPageV2",
  components: {
    ConnectionTabsRenderer,
    AmazonSellerCentralPage,
    // AmazonAdvertisingPage,
    AppPagination,
    AmazonConnectionPage,
    AppIcon,
    AppInput,
    AddAccountSideBar
  },
  data() {
    return {
      provider: "Amazon Seller Central",
      dataLoading: true,
      removeLoading: false,
      page: 1,
      perPage: 20,
      totalPages: 0,
      confirmRemoveModal: false,
      removeId: null,
      createAccountModal: false,
      currentTab: "connection",
      provider: "Amazon Seller Central",
      search: "",
      addAccountSideBar: false
    };
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace
    }),
    currentComponent() {
      return AmazonConnectionPage;
    }
  },
  async created() {},
  async mounted() {
    // Set `padded` to false to remove padding in `TheWrapperPrivate.innerPage` padding
    this.$store.dispatch("setPadded", false);
  },
  beforeUnmount() {
    // Reset the `padded` to true to add padding in `TheWrapperPrivate.innerPage` padding
    this.$store.dispatch("setPadded", true);
  },
  methods: {
    ...mapActions(["accountList", "authStatus", "workspaceList"]),
    handleTotalUpdate(totalData) {
      this.totalPages = totalData.totalPages;
    },
    updatePerPage(perPage) {
      this.page = 1;
      this.perPage = perPage;
    },
    AddAccountButtonClicked() {
      this.addAccountSideBar = true;
    }
  }
};